// Base API URL - adjust this based on your environment
//export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Other config values can be added here 
const getApiUrl = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'production':
        return process.env.REACT_APP_API_URL;
      default:
        return process.env.REACT_APP_API_URL;
    }
  };

const getGpuApiUrl = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'production':
        return process.env.REACT_APP_GPU_API_URL;
      default:
        return process.env.REACT_APP_GPU_API_URL;
    }
  };
  
export const API_URL = getApiUrl();
export const GPU_API_URL = getGpuApiUrl();

export const endpoints = {
    signin: `${API_URL}/auth/signin`,
    signup: `${API_URL}/auth/signup`,
    // resetpPassword: `${API_URL}/auth/reset-password`,
    courses: `${API_URL}/courses`,
    courseDetail: (id) => `${API_URL}/courses/${id}`,
}; 